class BackToTop extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.button = this.querySelector('button');
    this.scrollToTop = this.scrollToTop.bind(this);
    this.button.addEventListener('click', this.scrollToTop);
  }

  disconnectedCallback() {
    this.button.removeEventListener('click', this.scrollToTop);
  }

  scrollToTop() {
    window.scroll({
      top: 0,
      behavior: 'smooth',
    });
  }
}

if (!customElements.get('back-to-top')) {
  customElements.define('back-to-top', BackToTop);
}
